<style lang="scss" scoped>
</style>

<template>
  <c-layout>
    <!-- title -->
    <template #title>
      <div>Devices</div>
    </template>

    <!-- tool bar -->
    <template #toolbar>
      <!-- <button class="button" @click="drawer='register'">Register</button> -->
    </template>

    <!-- right side bar -->
    <template #drawer>
      <c-drawer v-show="drawer" @close="drawer=null">
        <register-form v-show="drawer=='register'" @complete="drawer=null"/>
      </c-drawer>
    </template>

    <!-- main -->
    <template #content>

      <!-- device table -->
      <c-sorted-table :values="devices" v-if="Object.values(devices).length" class="table is-fullwidth">
        <thead>
          <tr>
            <th><c-sort-link name="name">Name</c-sort-link></th>
            <th><c-sort-link name="location">Location</c-sort-link></th>
            <th><c-sort-link name="serial">Serial</c-sort-link></th>
            <th><c-sort-link name="heartbeat">Last Event</c-sort-link></th>
          </tr>
        </thead>
        <template #body="sort">
          <tbody>
            <tr v-for="device in sort.values" :key="device.serial">
              <td>{{device.name | ifndef('-')}}</td>
              <td>{{device.location | ifndef('-')}}</td>
              <td>{{device.serial}}</td>
              <td>{{device.heartbeat | time | relative}}</td>
            </tr>
          </tbody>
        </template>
      </c-sorted-table>

      <!-- no devices banner -->
      <c-missing v-else>No devices found.</c-missing>
    </template>
  </c-layout>
</template>

<script>
import Device from '@/models/device';
import RegisterForm from './register-form';


export default {
  name: 'devices',
  data () {
    return {
      drawer: null,
    };
  },
  components: {
    RegisterForm
  },
  computed: {
    devices: () => Device.all()
  },
};
</script>
